<template>
    <div v-if="$filteredObjects.length" class="house-tile-slider-wrap" :class="{ hidden: toggleSlider }">

        <flickity v-if="visible" class="house-tile-slider" ref="flickityhouse" :options="flickityOptions">
            <div class="house-tile-slider__item keep-polygon-active"
                 v-for="(house, i) in $filteredObjects"
                 :key="i"
                 ref="housetile"
                >
                <house-tile :houseindex="i" :house="house"></house-tile>
            </div>
        </flickity>
        <button class="btn-arrow icon-cross" @click="hideSlider"></button>

    </div>
</template>

<script>
    import Flickity from 'vue-flickity';

    import HouseTile from '../components/HouseTile.vue'

    export default {
        components: {
            Flickity,
            HouseTile
        },
        data() {
            return {
                visible: true,
                toggleSlider: false,
                flickityOptions: {
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    draggable: false
                },

                visiblehouses: [],
                parent: this.$parent
            }
        },
        watch: {
            $filteredObjects () {
                this.visible = false
                setTimeout(() => {
                    this.visible = true
                    if(this.$refs.flickityhouse) {
                        this.$refs.flickityhouse.select(0)
                    }
                },1)
            }
        },
        methods: {
            slideTo(e){
                // Slide to houseindex
                this.$refs.flickityhouse.select(e);

            },
            showSlider(){
                this.toggleSlider = false
            },

            hideSlider: function () {
                this.toggleSlider = !this.toggleSlider;
                this.parent.noActivePolygon();
            },

            hideSliderPopup: function () {
                this.toggleSlider = !this.toggleSlider

            }
        }
    }
</script>
